module.exports = __webpack_public_path__ + "static/media/ArbolFlor.a4d9ddcb.png";